var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.6b3b076f6bc548c763ab77af022604fb.svg#s';
                    var viewUrl = 'sprites.6b3b076f6bc548c763ab77af022604fb.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };